module.exports = __webpack_public_path__ + "img/vg.ccea90f.svg";